var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #ffffff;\n      }\n\n      .st1 {\n        stroke: #fbc02d;\n        stroke-miterlimit: 10;\n        stroke-width: .80px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.8.2h24v24h-24V.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.1,9.5l2,2c1.7-1.7,3.9-2.9,6.1-3.4.1-.2.9-1.4,3.1-1.4s3.2,1.5,3.2,1.5h0s0,0,0,0c2.1.6,4,1.7,5.6,3.3l2-2C17,3.4,7.2,3.4,1.1,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,17.9l-3,3-3-3c.6-.6,1.3-1,2.1-1.1v1.5h1.8v-1.5c.8.2,1.5.5,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,11.1c-.1.2-.8.9-1,1-.2,0-1.1.8-1.2,1.1,0,.2-.1.5-.1.7-1.6.1-3.1.8-4.3,2l-2-2c2.3-2.3,5.6-3.3,8.6-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9,13.9l-2,2c-1.1-1.1-2.4-1.7-3.7-2,.2-.3.8-1.1,1.1-1.3.4-.2,1-.8,1.1-1h0c1.3.5,2.5,1.2,3.5,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,14c0,.2,0,.5-.1.9h-2c0-.9.1-1.4.2-1.8s.5-.7,1-1.1l.6-.4c.2-.1.3-.3.4-.4.2-.3.3-.6.3-.9s-.1-.7-.3-1.1-.6-.5-1.2-.5-1,.2-1.2.6-.4.8-.4,1.2h-2.2c0-1.4.6-2.5,1.5-3.1.6-.4,1.3-.6,2.2-.6s2.1.3,2.8.8,1.1,1.4,1.1,2.4-.2,1.2-.5,1.7c-.2.3-.6.6-1.1,1l-.5.4c-.3.2-.5.5-.6.8h0ZM13,18.4h-2.2v-2.2h2.2v2.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiUnknown);
export default __webpack_public_path__ + "static/media/wifi_unknown.739b1b964cf2688a9e8e4037cc35629c.svg";
export { ForwardRef as ReactComponent };